import { Server, TerminalSquare } from 'lucide-react';
import type { HubSection } from '@/components/layout/HubLayout';

export const MCP_HUB_SECTIONS: HubSection[] = [
  {
    id: 'servers',
    label: 'Servers',
    icon: Server,
    description: 'Register and manage MCP servers for your organization.',
  },
  {
    id: 'setup',
    label: 'Setup',
    icon: TerminalSquare,
    description: 'Connect Cursor, Claude Desktop, or any MCP-compatible client.',
  },
];

export const DEFAULT_MCP_HUB_SECTION = 'servers';

export function mcpHubSection(id: string): HubSection | undefined {
  return MCP_HUB_SECTIONS.find((s) => s.id === id);
}
